"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AgreeFitProtocalRequest = void 0;
var AgreeFitProtocalRequest = /** @class */ (function () {
    function AgreeFitProtocalRequest() {
    }
    return AgreeFitProtocalRequest;
}());
exports.AgreeFitProtocalRequest = AgreeFitProtocalRequest;
//# sourceMappingURL=agreeFitProtocal.request.js.map